import React from "react";
import Menutest from "./menu.js";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import "../just.css";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import Table from "react-bootstrap/Table";

import { connect } from "react-redux";
import axios from "axios";
import {
  Grid,
  Segment,
  Divider,
  Header,
  Input,
  Form,
  Menu,
  Modal,
  Item,
  Button,
  Radio,
  Checkbox,
  Pagination,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { List, Image, Icon } from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import ReactTooltip from "react-tooltip";
import { API_BASE_URL } from "../utils/endpoints";

const modEdit = {
  marginTop: 200,
  marginLeft: "35%",
  height: "auto",
  textAlign: "left",
};

const modEdita = {
  marginTop: 200,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
};

const modDelete = {
  marginTop: 200,
  marginLeft: 520,
  height: "auto",
  textAlign: "left",
};

const modDeletea = {
  marginTop: 200,
  marginLeft: 300,
  height: "auto",
  textAlign: "left",
};

class SenderID extends React.Component {
  state = {
    persons: [],
    personsearch: [],
    id: "",
    show: false,
    isArabic: false,
    superOperator: false,
    totalpage: 1,
    activePage: 1,
    senderId_name: "",
    senderId_isAdv: false,

    searchtotalpage: 1,
    isAdv: false,

    searchWord: "",
    totalpageSearch: "1",
    modalOpenAdd: false,
    modalOpenEdit: false,
    modalOpenDelete: false,

    ////////////// from edit sender id and the same state from add sender id //////////
    sender_id: "",
    id: "",
    account_status_value: false,
    account_status: false,
    modalOpenCustomerName :false

    ///////////////////////////
  };

  handleOpenAdd = () => this.setState({ modalOpenAdd: true });
  handleCloseAdd = () => this.setState({ modalOpenAdd: false });

  handleOpenEdit = () => this.setState({ modalOpenEdit: true });
  handleCloseEdit = () => this.setState({ modalOpenEdit: false });

  handleOpenDelete = () => this.setState({ modalOpenDelete: true });
  handleCloseDelete = () => this.setState({ modalOpenDelete: false });

  handleOpenCustomerName = () => this.setState({ modalOpenCustomerName: true });
  handleCloseCustomerName = () => this.setState({ modalOpenCustomerName: false });


  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".blues_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".fixed_report").style =
        "margin-right: 0% !important;";
    }

    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var data = { query: "", page: page_num };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.Sender_ids !== undefined) {
        this.setState({ persons: res.data.result.Sender_ids });

        var total = res.data.result.count / 20;
        this.setState({ totalpage: total });
      }
    });
  }
  searchchange = (event) => {
   // window.scrollTo(0, 0);
    this.setState({ searchWord: event.target.value });
    if (event.target.value.length >= 2) {
      document.querySelector(".pagination").style = "display:none";
      document.querySelector(".searchpagination").style = "display:block";

      var token = reactLocalStorage.get("accessToken");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var page_num = 0;
      var data = { query: event.target.value, page: page_num };
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        if (res.data.result.Sender_ids !== undefined) {
          this.setState({ persons: res.data.result.Sender_ids });
          var total = res.data.result.count / 20;
          this.setState({ totalpagesearch: total });
        }
      });
    } else if (event.target.value == "") {
      //document.querySelector(".view_basic").style = "display:block";
      //document.querySelector(".view_search").style = "display:none";
      this.componentDidMount();
    }
  };

  Deleteform = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");

    this.setState({ id: event.target.id });
    var id_user = event.target.id;

    var apiBaseUrl;
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var body={sender_id:id_user}
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/deleteSenderId/"+id_user 
        
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/senderid/deleteSenderId/"+id_user 
        
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, {},{ headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "SenderID";
          }

          if (response.data.status === "failed") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErroeDiscreption,
              animation: "bounce",
              time: 5000,
            });
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    //window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var data = { query: this.state.searchWord, page: page_num };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.Sender_ids !== undefined) {
        this.setState({ persons: res.data.result.Sender_ids });
        var total = res.data.result.count / 20;
        this.setState({ totalpage: total });
      }
    });
  };

  handlePaginationChangeSearch = (e, { activePage }) => {
    this.setState({ activePage });
    //window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var data = { query: this.state.searchWord, page: page_num };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.Sender_ids !== undefined) {
        this.setState({ persons: res.data.result.Sender_ids });
        var total = res.data.result.count / 20;
        this.setState({ totalpageSearch: total });
      }
    });
  };

  ////////////////// from edit sender id ////////////////

  onChangesenderid = (event) => {
    this.setState({ sender_id: event.target.value });
  };

  Editform = (event) => {
    var id = event.target.id;
    reactLocalStorage.set("id_user_edit_sender", event.target.id);
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var data = { query: "", page: page_num };
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/searchSenderIds";
    }
    var i;
    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.Sender_ids !== undefined) {
        for (i = 0; i < res.data.result.Sender_ids.length; i++) {
          if (res.data.result.Sender_ids[i].id === id) {
            console.log(res.data.result.Sender_ids[i].sender_id);
            console.log(res.data.result.Sender_ids[i].adv);

            this.setState({
              sender_id: res.data.result.Sender_ids[i].sender_id,
            });
            this.setState({
              senderId_isAdv: res.data.result.Sender_ids[i].adv,
            });

            // reactLocalStorage.set('sender_id',res.data.result.Sender_ids[i].sender_id)
            //reactLocalStorage.set('senderId_isAdv',res.data.result.Sender_ids[i].adv)
            this.setState({ modalOpenEdit: true });

            if (this.state.senderId_isAdv === false) {
              this.setState({ account_status_value: false });
            } else if (this.state.senderId_isAdv === true) {
              this.setState({ account_status_value: true });
            }
          }
        }
      }
    });
  };

  handleSubmitEdit = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");
    const user = {};
    var data = user;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;

    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/updateSenderId/" +
        reactLocalStorage.get("id_user_edit_sender") +
        "/" +
        this.state.sender_id +
        "/" +
        this.state.account_status_value;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/senderid/updateSenderId/" +
        reactLocalStorage.get("id_user_edit_sender") +
        "/" +
        this.state.sender_id +
        "/" +
        this.state.account_status_value;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "SenderID";
          }

          if (response.data.status === "failed") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErroeDiscreption,
              animation: "bounce",
              time: 5000,
            });
          }
        } else if (response.data.status != "success") {
          toast({
            type: "warning",
            title: i18n.t("warning.label"),
            description: response.data.status,
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  ////////////////// from add sender id ////////////////

  onChangeaccount = (event) => {
    const newArray = [];
    var i;
    for (i = 0; i < event.length; i++) {
      if (newArray.includes(event[i].value) === false) {
        newArray.push(event[i].value);
      }
    }
    this.setState({ selectedValues: newArray }, function() {});
  };

  AddAdv = (event) => {
    this.setState({ isAdv: !this.state.isAdv });
    if (this.state.enable === false) {
      this.setState({ enable: true });
    } else {
      this.setState({ enable: false });
    }
  };

  EditAdv = (event) => {
    this.setState({ account_status_value: !this.state.account_status_value });
    /*  if(this.state.account_status_value === false)
    {
      this.setState({account_status_value:true})
      document.getElementById("data_check").checked = true;
    }
    else if (this.state.account_status_value === true){
     this.setState({account_status_value:false})
     document.getElementById("data_check").checked = false;
    }  */
  };

  handleSubmitAdd = (event) => {
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");
    const user = {
      sender_id: this.state.sender_id,
      isAdv: this.state.isAdv,
    };
    var data = user;

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/createSenderId";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/senderid/createSenderId";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status) {
            window.location = "SenderID";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  render() {
    const { activePage, sender_id, senderId_isAdv } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={3} divided className="fixed_report">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style blues_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="id badge" color="black" />
                    {this.state.isArabic
                      ? "تعريف المرسلين"
                      : " View Sender IDs"}
                  </Header>
                </Divider>
                <br />

                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن اسم المرسل"
                        : "Search By  Sender Name"
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  {reactLocalStorage.get("role") === "ROLE_OPERATOR_INT" ||
                  reactLocalStorage.get("role") === "ROLE_OPERATOR" ? (
                    <Button
                      floated="right"
                      icon="add"
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.handleOpenAdd}
                    >
                      {this.state.isArabic
                        ? "إضافة مرسل جديد"
                        : "New Sender ID"}
                      <Icon
                        color="black"
                        name="pencil alternate"
                        color="black"
                      />
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
                <br />
                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td style={{ textAlign: "center" }}>{i18n.t("Name.label")} </td>
                      <td style={{ textAlign: "center" }}>ADV</td>
                      <td style={{ textAlign: "center" }}>{this.state.isArabic ? "عرض اسماء الزبائن" : " View Customer Name"}</td>
                     
                      {reactLocalStorage.get('role')=='ROLE_OPERATOR' ?    <td style={{ textAlign: "center" }}>{this.state.isArabic ? "إعدادات" : "Settings"}</td>:null}
                    </tr>
                  </thead>
                  {this.state.persons.map((person) => (
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }}>{person.sender_id}</td>
                        <td style={{ textAlign: "center" }}>{person.adv==false?'false':'true'}</td>

                        <td style={{ textAlign: "center" }} >


                        <Modal  closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                              size="tiny"
                              className="filter"
                              trigger={
                                <Icon
                                  
                                className="eye"
                                name="eye"
                                
                                  floated={
                                    this.state.isArabic ? "left" : "right"
                                  }
                                />
                              }
                              style={
                                this.state.isArabic ? modDeletea : modDelete
                              }
                              floated={this.state.isArabic ? "right" : "left"}
                            >
                <Header content=  {i18n.t("Contact_List.label")} />
                <Modal.Content scrolling>
                
                <Form>

                <Table hover  responsive border="0" style={{textAlign:this.state.isArabic?'right':'left'}}  >
                <thead className="head">
                <tr>
                <td>  #</td>
                <td> {this.state.isArabic?'اسم الزبون':'Customer Name'}</td>
           
                </tr>
                </thead>
                <tbody>
                {person.customer_name!=null?person.customer_name.map((record,index) => (
                <tr>
                <td>

                  {index+1}

        

                </td>
                <td>{record}</td>
             
                </tr>
                ))
              :
              ''
              }
                </tbody>

                </Table>
                </Form>
                </Modal.Content>
               
                </Modal>
                         
                          

                           
                          
                         
                        </td>

                     

                       {reactLocalStorage.get('role')=='ROLE_OPERATOR' ?  <td style={{ textAlign: "center" }}>
                       
                           {/*  <Icon
                            className="eye"
                              
                              name="edit outline"
                              color="black"
                              id={person.id}
                              value={person.isAdv}
                              onClick={this.Editform}
                            /> */}

                            <Modal
                             closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
                              size="tiny"
                              className="filter"
                              trigger={
                                <Icon
                                  
                                  className="eye"
                                  name="trash alternate outline"
                                  color="black"
                                  floated={
                                    this.state.isArabic ? "left" : "right"
                                  }
                                />
                              }
                              style={
                                this.state.isArabic ? modDeletea : modDelete
                              }
                              floated={this.state.isArabic ? "right" : "left"}
                            >
                              <Header
                                icon="trash alternate outline"
                                content={this.state.isArabic ? "حذف" : "Delete"}
                              />
                              <Modal.Content>
                                <Header as="h3" textAlign="center">
                                  {" "}
                                  {this.state.isArabic
                                    ? " ؟ هل انت متأكد من حذف هذا المرسل"
                                    : " Are you sure you want to delete this SenderID ? "}
                                </Header>
                              </Modal.Content>
                              <Modal.Actions>
                                <Button
                                  basic
                                  color="teal"
                                  content={i18n.t("delete.label")}
                                  id={person.id}
                                  onClick={this.Deleteform}
                                />
                                <Button
                                  basic
                                  color="black"
                                  content={i18n.t("Cancel.label")}
                                  onClick={() => {
                                    window.location = "SenderID";
                                  }}
                                />
                              </Modal.Actions>
                            </Modal>
                       
                        </td> :null}
                      </tr>
                    </tbody>
                  ))}
                </Table>

                <br />

                <div className="pagination" style={{ display: "block" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChange}
                        totalPages={this.state.totalpage}
                        className="page"
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>

                <div className="searchpagination" style={{ display: "none" }}>
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationChangeSearch}
                        totalPages={this.state.searchtotalpage}
                        className="page"
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>
          </div>

          <Modal
            size="tiny"
            className="filter"
            style={this.state.isArabic ? modEdita : modEdit}
            open={this.state.modalOpenEdit}
            onClose={this.handleCloseEdit}
            closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
          >
            <Header
              icon="edit outline"
              content={this.state.isArabic ? "تعديل " : "Edit SenderId"}
            />
            
            <Modal.Content>
              <Form>
                <Form.Input
                  fluid
                  label={i18n.t("sender_id.label")}
                  onChange={this.onChangesenderid}
                  value={sender_id}
                  placeholder={this.state.sender_id}
                  style={{ width: "100%" }}
                />
                <Form.Field>
                  <Checkbox
                    label={i18n.t("adv.label")}
                    style={{ width: "20%" }}
                    onClick={this.EditAdv}
                    id="data_check"
                    style={{ width: "34%" }}
                    defaultChecked={senderId_isAdv}
                  />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={this.handleSubmitEdit}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseEdit}
              />
            </Modal.Actions>
          </Modal>

          <Modal
            size="tiny"
            closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            className="filter"
            style={this.state.isArabic ? modEdita : modEdit}
            open={this.state.modalOpenAdd}
            onClose={this.handleCloseAdd}
          >
            <Header
              icon="pencil alternate"
              content={i18n.t("create_sender_id.label")}
            />
            <Modal.Content>
              <Form
                style={{
                  textAlign:
                    reactLocalStorage.get("lang") === "ar" ? "right" : "left",
                }}
              >
                <Form.Input
                  fluid
                  label={i18n.t("sender_id.label")}
                  placeholder={
                    this.state.isArabic ? "اسم المرسل" : "Sender ID Name"
                  }
                  style={{ width: "100%" }}
                  onChange={this.onChangesenderid}
                />
                <Form.Field floated="left">
                  <Checkbox label={i18n.t("Adv.label")} onClick={this.AddAdv} />
                </Form.Field>
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={this.handleSubmitAdd}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseAdd}
              />
            </Modal.Actions>
          </Modal>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(SenderID);
